import React, { FC } from 'react';
import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';

import sx from '../../internal/styles/sx';
import Box from '../../layouts/Box';
import type { AlertProps } from './types';
import base from './variants/base';
import softTypeVariant from './variants/soft/typeVariant';
import solidTypeVariant from './variants/solid/typeVariant';

const BaseAlert = styled(Box, {
  shouldForwardProp,
})<AlertProps>(base, sx);

const SolidAlert = styled(BaseAlert)(solidTypeVariant);
const SoftAlert = styled(BaseAlert)(softTypeVariant);

const themeComponents = {
  solid: SolidAlert,
  soft: SoftAlert,
};

const Alert: FC<AlertProps> = ({ children, theme = 'solid', ...props }) => {
  const ComponentAlert = themeComponents[theme];
  return <ComponentAlert {...props}>{children}</ComponentAlert>;
};

export default Alert;
